export default "__VITE_ASSET__B5i8u0e1__"